import type { useEditScope } from './useEditScope'

type Scope = ReturnType<typeof useEditScope>

/**
 * Доступность области правки — вынесено из `EditBlockSettings`, чтобы новый
 * вариант `EditScope` ломал сборку здесь, а не проскакивал в `default`.
 */
export const isEditScopeAvailable = (scope: Scope): boolean => {
  switch (scope.scope) {
    case 'block':
      return scope.hasBlock
    case 'lesson':
      return scope.hasLessonBlocks
    case 'selection':
      return scope.hasSelection
    default: {
      const _unhandled: never = scope.scope
      return _unhandled
    }
  }
}
